import { colors } from '@ajaibid/components';
import { css } from '@emotion/css';

export const styContainerAccordion = css`
  width: 100%;
  max-width: 580px;
`;

export const styTitleAccordion = css`
  margin-top: 12px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 800;
  font-size: 14px;
  color: ${colors.NEUTRAL_10};
`;

export const styleBodyAccordion = css`
  margin-top: 12px;
  font-weight: 400;
  font-size: 14px;
  color: ${colors.NEUTRAL_7};
`;
